import api, { fisgApi } from "@/api";
import store from '@/store/store.js'

// Token Refresh
let isAlreadyFetchingAccessToken = false;
let subscribers = [];

function onAccessTokenFetched(access_token) {
  subscribers = subscribers.filter(callback => callback(access_token));
}

function addSubscriber(callback) {
  subscribers.push(callback);
}

export default {
  init() {
    const apis = [api, fisgApi];

    apis.forEach((apiObj) => {
      apiObj.interceptors.request.use((config) => {
        const token = store.getters['auth/accessToken'];
        config.headers.Authorization = token ? `Bearer ${token}` : '';
        return config;
      });

      apiObj.interceptors.response.use(function (response) {
        return response;
      }, async function (error) {
        const { config, response } = error;
        const originalRequest = config;

        if (response && response.status === 401 && !originalRequest._retry) {
          if (!isAlreadyFetchingAccessToken) {
            isAlreadyFetchingAccessToken = true;
            store.dispatch('auth/fetchAccessToken').then((newToken) => {
              isAlreadyFetchingAccessToken = false;
              onAccessTokenFetched(newToken);
            });
          }

          const retryOriginalRequest = new Promise((resolve) => {
            addSubscriber((newToken) => {
              originalRequest.headers.Authorization = `Bearer ${newToken}`;
              resolve(apiObj(originalRequest));
            });
          });

          return retryOriginalRequest;
        }

        return Promise.reject(error);
      });
    });
  },
};
